export default "/images/e3d9a898d270c82a26b97d0e4e91a468.avif";